import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSurfingNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M10.385 10.166c5.19-5.19 9.6-7.624 12.935-8.605 1.665-.49 3.072-.62 4.173-.539.549.04 1.037.134 1.45.272.39.13.806.33 1.12.643s.513.73.643 1.12c.138.413.231.901.272 1.45.08 1.101-.05 2.508-.54 4.173-.776 2.639-2.462 5.951-5.704 9.791l.57 1.367c.734 1.546 2.653 2.016 4.001 1.115l1.04-.695 1.39 2.078-1.04.695c-2.589 1.73-6.274.838-7.668-2.16a1.278 1.278 0 01-.02-.046l-.122-.29c-.337.356-.687.716-1.051 1.08a54.243 54.243 0 01-4.274 3.858 2.75 2.75 0 003.946.363l1.677-1.448a1.25 1.25 0 011.822.203l.598.808a2.75 2.75 0 003.525.782l.942-.512 1.194 2.196-.942.512a5.25 5.25 0 01-6.517-1.223l-.664.574c-2.304 1.991-5.758 1.589-7.569-.737-4.762 3.43-8.068 4.327-8.643 4.464a1.34 1.34 0 01-1.26-.36L.903 26.333a1.34 1.34 0 01-.359-1.261c.191-.802 1.864-6.929 9.84-14.905zm17.95-6.319a1.361 1.361 0 00-.051-.131 1.355 1.355 0 00-.131-.05 3.544 3.544 0 00-.843-.15c-.76-.056-1.864.026-3.284.444-2.838.834-6.898 3-11.873 7.974-6.375 6.374-8.44 11.407-9 13.112l1.018 1.017L21.657 8.576l1.768 1.768L5.939 27.83l1.015 1.016c1.705-.56 6.738-2.624 13.112-9 4.975-4.974 7.14-9.035 7.974-11.872.418-1.42.5-2.525.444-3.284a3.545 3.545 0 00-.15-.843z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSurfingNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSurfingNormalMedium;
